<div class="flex-space-between flex-centered-container-vr search-dialog-title" matDialogTitle>
    <h3 class="no-margin">Search Symbol</h3>

    <span class="spacer"></span>

    <button mat-icon-button matDialogClose>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="search-container">
    <mat-form-field class="full-width dense-form-feild condensed-select-field" appearance="outline" color="accent">
        <mat-label>Search Symbol</mat-label>

        <input matInput type="text" [formControl]="searchCtrl" autocomplete="false">
    </mat-form-field>

    <div class="search-result">
        <mat-list dense>
            <mat-list-item *ngFor="let item of symbols">
                <div class="name">
                    {{ item.market_id }} {{ item.scrip_name }}
                </div>

                <span class="spacer"></span>

                <button mat-stroked-button color="accent" (click)="add(item)">
                    Add

                    <mat-icon>add</mat-icon>
                </button>
            </mat-list-item>
        </mat-list>

        <div class="search-hint flex-centered-container" *ngIf="!searchCtrl.value">
            <div class="hint flex-centered-container display-flex-column">
                <mat-icon class="search-icon" color="accent">search</mat-icon>
                Search symbol above
            </div>
        </div>
    </div>
</div>